<template>
  <div class="wrapper-template terms-wrap"
       id='sectionContainer'>
    
    <div class="inner-wrapper-one">
      <div class="wrapper-template__inner wrapper-template__inner_flex-col">

        <div class="part">
          <div class="terms-title">
            {{lang.mainTitle}}
          </div>
        </div>

        <!-- <div class="part" :key="item.$index"
             v-for="item in lang.parts">
          <p class="text text_b">{{item.title}}</p>

          <p class="text" :key="paragraph.$index"
             v-for="paragraph in item.paragraphs"
             v-html="paragraph.text"></p>
        </div> -->

        <div :class="{'part': item.isPart}" :key="item.$index"
             v-for="item in lang.parts">
          <p class="text text_b" v-if="item.title">{{item.title}}</p>

          <p class="text" :key="paragraph.$index"
             v-for="paragraph in item.paragraphs"
             v-if="!item.isList"
             v-html="paragraph.text"></p>
          
          <ul class="menu-inner-list" v-if="item.isList">
            <li class="menu-inner-list__item"
                :key="listItem.$index"
                v-for="listItem in item.list"
                v-html="listItem.item"></li>
          </ul>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import switchClasses from '@/util/switcherClasses.js'

export default {
  name: 'CookiePolicy',

  data() {
    return {
      lang: this.$root.$options.LANG.TERMS.cookiesPolicy,
    }
  },

  mounted: function() {
    switchClasses({add: 'show',remove: 'hide'}, 'sectionContainer');
    this.$emit('isNotFound', [{is: true}]);
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import 'terms&etc.scss';
</style>
